import ApprovalContents from '@/components/MobileApproval/ApprovalContents';
import useSWRInfinite from 'swr/infinite';
import { Approval } from '@/types/api';
import { getApprovalkey, MAX_LIST_SIZE } from '@/components/MobileApproval';
import { APPROVAL_SEARCH_URL } from '@/constant/approval';
import { approvalSearchListFetcher } from '@/hooks/apiHooks/approval';
import Loading from '@/components/MobileApproval/Body/Loading';
import ApprovalSkeleton from '@/components/MobileApproval/ApprovalSkeleton';
import ErrorMessage from '@/components/MobileSales/ErrorMessage';
import React from 'react';
import { useAtomValue } from 'jotai';
import { MyInfoState } from '@/recoil/atom';
import { useGetCombinedDepartment } from '@/hooks/apiHooks';
import { ContentLayout } from '@/components/MobileApproval/ApprovalContents/styles';

const TeamApproval = () => {
  const myInfo = useAtomValue(MyInfoState);
  const params = `${myInfo.departmentId}`;
  const { data: orgData } = useGetCombinedDepartment(params);

  const { data, size, setSize, isLoading, error, mutate } = useSWRInfinite<
    Approval[]
  >(
    getApprovalkey(APPROVAL_SEARCH_URL, {
      listSize: MAX_LIST_SIZE,
      sortType: 'authoredAt',
      orderType: 'desc',
      approverDepartmentIds: orgData,
    }),
    approvalSearchListFetcher<Approval>,
    {
      shouldRetryOnError: false, // 에러 발생 시 재시도를 하지 않도록 설정
      revalidateOnFocus: false,
    },
  );

  const resultData = data?.reduce((prev, next) => prev.concat(next));

  const readMoreData = () => {
    setSize(size + 1);
  };
  const isReachingEnd = data && data[data.length - 1]?.length < MAX_LIST_SIZE;

  const handleRefresh = () => mutate();

  return (
    <ContentLayout>
      {isLoading ? (
        <>
          {Array.from({ length: 10 }, (_, i) => (
            <ApprovalSkeleton key={`ApprovalSkeleton-${i}`} />
          ))}
        </>
      ) : error ? (
        <ErrorMessage
          errorMessage={error?.response?.data?.message}
          errorCode={error?.response?.data?.status}
          refresh={handleRefresh}
        />
      ) : (
        <ApprovalContents data={resultData} onRefresh={handleRefresh} />
      )}
      {data && !isLoading && !isReachingEnd && (
        <Loading readMoreData={readMoreData} />
      )}
    </ContentLayout>
  );
};
export default TeamApproval;
